import {useQuery} from "@apollo/client";
import {GetDesignBlocks} from "./DesignBlock.js";

export function useGetDesignBlocks(params = {}) {
    const {data, previousData, loading, error, refetch, variables} = useQuery(
        GetDesignBlocks,
        {...params, notifyOnNetworkStatusChange: true}
    );
    
    let holder = (data && data['GetDesignBlocks']) ? data : previousData;
    const extracted = (holder) ? holder['GetDesignBlocks'] : [];

    if(error) console.log(error);

    return {
        data: extracted, 
        loading: (loading && !previousData), 
        refetch, 
        variables,
        error: error
                ? <div className="bg-red-600 text-white px-4 py-2 mt-1 rounded-md">{error?.message}</div>
                : null
    }
}
export async function asyncGetDesignBlocks(variables = {}, apolloClient) {
    const {data, loading} = await apolloClient.query({
        query: GetDesignBlocks,
        variables
    });
    const extracted = data ? data['GetDesignBlocks'] : [];
    return {
        data: extracted,
        loading: loading,
        variables
    }
}
